module.exports = __webpack_public_path__ + "static/img/JessicaFox.a668fb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JessicaFox.jpg
// module id = RTAW
// module chunks = 0